/*
 * Action Types
 */
export enum SupervisorsTypes {
  SET_SUPERVISORS_LIST = '@supervisors/SET_SUPERVISORS_LIST',
}

/*
 * Data Types
 */
export interface SupervisorsInterface {
  email: string;
  modules: string[];
}

/*
 * State type
 */
export interface SupervisorsState {
  readonly supervisorsList: SupervisorsInterface[];
}
